import React from 'react';
import {Text, View, Link} from '@react-pdf/renderer';
import styles from '../../Foundations/Utils/PDFUtils'

const filterLists: string [] = [
    'Duration of rental tem (1, 5, 7, 15, 21 and 30 days),',
    'Radius of search from the central point of the specified location,',
    'Vehicle type,',
    'Car class (as determined by the car rental provider and specified via the XML connection, using this filter may not reveal cars classified as per industry standards),',
    'Car model,',
    'Supplier (car rental provider brand), and',
    'Depot (rental pick up location)'
];

interface DoubleBulletedList {
    name: string,
    children?: string []
}

const noRatesReasons: DoubleBulletedList [] = [
    { 
        name: 'Depot closures due to:',
        children: [
            'COVID-19 pandemic such as lockdowns or reduced operations.',
            'Floods or other emergency circumstances',
            'Seasonality, and'
        ]
    },
    { name: 'Inventory sell-out impacted by seasonality, high demand and low fleet levels,' },
    { name: 'Vehicles not available for same day pick up, or' },
    { name: 'Vehicles that require a minimum rental duration to appear in search results.' }
]

const AboutPage: React.FC = () => (
  <View>
      <Text style={{...styles.fontBold, ...styles.aboutPageHeaderText, marginBottom: '19pt' }}>About VroomVroomVroom</Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          VroomVroomVroom operates rental car comparison and booking websites and apps, including the flagship site: <Link style={{color: '#0a68ff'}} src={'https://www.vroomvroomvroom.com.au/'}>www.vroomvroomvroom.com.au</Link>. VroomVroomVroom has been operating since 2001 and has assisted over 3,500,000 customers.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          All car rental rates offered on VroomVroomVroom are live for available vehicles as specified by car rental providers.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          When a customer makes a car rental reservation on Vroom, their reservation is made and confirmed in the car rental provider’s reservation software, as if the reservation is made directly with the car rental provider.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          In other words, if inventory is unavailable for reservation, it will not be offered for reservation on VroomVroomVroom.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          To explain in further detail:
      </Text>
      <View style={{marginBottom: '14pt'}}>
          <View style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
              <View style={styles.dot}/>
              <Text style={styles.aboutPageBodyText}>
                  VroomVroomVroom and car rental providers use an XML connection to facilitate car rental reservations.
              </Text>
          </View>
          <View style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
              <View style={styles.dot}/>
              <Text style={styles.aboutPageBodyText}>
                  Car rental providers' back end reservation systems indicate actual live availability for inventory and rates.
              </Text>
          </View>
          <View style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
              <View style={styles.dot}/>
              <Text style={styles.aboutPageBodyText}>
                  Car rental providers’ permit VroomVroomVroom access, via an application programming interface (‘API’) and XML connectivity, to the car rental provider's back end reservation systems.
              </Text>
          </View>
          <View style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
              <View style={styles.dot}/>
              <Text style={styles.aboutPageBodyText}>
                  When a search is made via the VroomVroomVroom booking engine, available inventory and published rates are accessed by VroomVroomVroom and offered to the customer.
              </Text>
          </View>
          <View style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
              <View style={styles.dot}/>
              <Text style={styles.aboutPageBodyText}>
                  If a customer selects and confirms the inventory via the VroomVroomVroom booking engine, the car rental provider confirms the reservation at the published rates without any requirement for bookings to be subsequently confirmed by the provider.
              </Text>
          </View>
      </View>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          The agreements between VroomVroomVroom and the providers require the providers to honour the rates advertised on the VroomVroomVroom website. Where a provider is unable to honour the rates due to unforeseen circumstances VroomVroomVroom requires that the provider provide an acceptable alternative or otherwise provide adequate compensation to the customer. This occurs in a very small number of cases.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          If a provider ever were to consistently fail to honour our customers bookings, VroomVroomVroom would no longer offer that provider’s vehicles.
      </Text>
      <Text style={{...styles.aboutPageHeaderText, ...styles.fontBold, fontSize: '8pt', marginBottom: '8pt'}}>
          What is Ratency database?
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          Ratency is a database of historical daily rates and availability for car hire, offered for booking by rental car providers and obtained by VroomVroomVroom via electronic XML connection and API (as explained above).
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          Rates data and availability for Ratency are accessed by VroomVroomVroom using XML calls, generally made twice per day. Rental car providers may change their pricing from time to time during a day and VroomVroomVroom makes no representations about the prices displayed, including whether they are the lowest or highest available for a particular day.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          Rates data contained in the database are rates set by the car rental providers and are not modified or marked up by VroomVroomVroom in any way. Raw data returned by a car rental provider’s API is available for reproduction subject to scope and quote.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          While we make reasonable efforts to provide accurate and reliable data, the data is provided ‘as is’ and VroomVroomVroom does not warrant that it will be without error or defect free, for example, car rental provider error in rate pricing occuring in its back end reservation system. Data is intended to be indicative of pricing information and availability for the search parameters and we make no guarantee or warranties regarding its accuracy, completeness or reliability.
      </Text>
      <Text style={{...styles.aboutPageHeaderText, ...styles.fontBold, fontSize: '8pt', marginBottom: '8pt'}}>
          About Ratency Reports
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          The rates data contained in this report was returned in response to a search in the Ratency database, via ratency.com, for rates offered by rental car providers with the search parameters identified on page 1.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '12pt'}}>
          Subscribing users run a search via ratency.com by specifying the search location and car hire pick up date. Search results specify the daily rates offered by car rental companies on the pick up date, for pick up on the same day. Users are offered filters for:
      </Text>
      {
          filterLists.map((item: string, index: number) => (
              <View key={index} style={{...styles.row, marginTop: '2pt', marginBottom: '2pt', paddingRight: '32pt'}}>
                  <View style={styles.dot}/>
                  <Text style={styles.aboutPageBodyText}>{item}</Text>
              </View>
          ))
      }
      <Text  style={{...styles.aboutPageBodyText, marginTop: '18pt'}}>
          Reports exported with filters selected are identified with search parameters on page 1. Where a car class filter has been selected, Reports will indicate rates for vehicle models which a rental provider has specified as belonging to that class. Reports may be exported without filters. The DATE field on the report is the same day pick up date searched by the User.
      </Text>
      <Text style={{...styles.aboutPageHeaderText, ...styles.fontBold, fontSize: '8pt', marginTop: '14pt', marginBottom: '8pt'}}>
          Ancillary pricing and excess reduction products
      </Text>
      <Text  style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          Only some ancillary pricing is available via XML connection. Data for ancillary pricing which is not available via XML connection and excess reduction products are collected manually by VroomVroomVroom.
      </Text>
      <Text style={{...styles.aboutPageHeaderText, ...styles.fontBold, fontSize: '8pt', marginBottom: '8pt'}}>
          Depots with Results and Depots with No Rates Available
      </Text>
      <Text  style={{...styles.aboutPageBodyText, marginBottom: '14pt'}}>
          Depots with Results are depots which had inventory available for reservation at the time that VroomVroomVroom made the XML call.
      </Text>
      <Text style={{...styles.aboutPageBodyText, marginBottom: '12pt'}}>
          There are numerous reasons why depots may not have rates available at the time of the XML call including:
      </Text>
      {
          noRatesReasons.map((item: DoubleBulletedList, index: number) => (
              <View key={index}>
                  <View style={{...styles.row, marginTop: '4pt', marginBottom: '4pt', paddingRight: '32pt'}}>
                        <View style={styles.dot}/>
                        <Text style={styles.aboutPageBodyText}>{item.name}</Text>
                  </View>
                  {
                    item.children ?
                    item.children.map((child: string, childIndex: number) => (
                        <View key={childIndex} style={{...styles.row, marginTop: '4pt', marginBottom: '4pt', paddingRight: '32pt', paddingLeft: '28pt'}}>
                            <View style={styles.dot}/>
                            <Text style={styles.aboutPageBodyText}>{child}</Text>
                        </View>
                    )) : null
                  }
              </View>
          ))
      }
  </View>
);

export default AboutPage;
